import type { Tweet } from '@/types/api';
import { formatDate } from '@/lib/utils';
import { TweetHeader } from './TweetHeader';
import { TweetContent } from './TweetContent';
import { TweetMedia } from './TweetMedia';
import { TweetMeta } from './TweetMeta';

interface TweetCardProps {
  tweet: Tweet;
  onImageClick: (url: string) => void;
}

export function TweetCard({ tweet, onImageClick }: TweetCardProps) {
  const date = formatDate(tweet.created_at);
  const tweetUrl = `https://twitter.com/${tweet.screen_name}/status/${tweet.rest_id}`;

  return (
    <article className="tweet-card bg-bg-secondary border border-border rounded-xl p-4 hover:border-accent transition-colors">
      <TweetHeader tweet={tweet} />
      <TweetContent text={tweet.full_text} />
      <TweetMedia media={tweet.media_urls} onImageClick={onImageClick} />
      <TweetMeta date={date} likes={tweet.favorite_count} retweets={tweet.retweet_count} tweetUrl={tweetUrl} />
    </article>
  );
}
